//
// user.js
//
const baseUrl = '/api/cms';

window.apiClient = {
  async fetchContent(options) {
    const {
      modelName,
      isCollection = true, // whether to use items or item, according to whether it is Collection or Singleton
      filter = null,
      sort = null,
    } = options;

    // Build the URL - Collection or Singleton endpoint
    const url = `${baseUrl}/${isCollection ? 'items' : 'item'}/${modelName}`;

    // Add query parameters
    const queryParams = new URLSearchParams();

    // Add filter if provided
    if (filter) {
      queryParams.append('filter', JSON.stringify(filter));
    }

    // Add sort if provided
    if (sort) {
      queryParams.append('sort', JSON.stringify(sort));
    }

    // Append query parameters to URL if we have any
    const queryString = queryParams.toString();
    const finalUrl = queryString ? `${url}?${queryString}` : url;

    const response = await fetch(finalUrl);
    if (!response.ok) throw new Error(`CMS request returned ${response.status}`);
    return response.json();
  },
};
